const clientLanguages = [
    {
        "name": "English",
        "code": "en",
    },
    {
        "name": "Spanish",
        "code": "es",
    },
    {
        "name": "French",
        "code": "fr",
    },
    {
        "name": "German",
        "code": "de",
    },
]

const dashboardLanguages = [
    {
        "name": "English",
        "code": "en"
    },
    {
        "name": "Hungarian",
        "code": "hu"
    },
]

export function fetchClientLanguages() {
    return clientLanguages
}

export function fetchDashboardLanguages() {
    return dashboardLanguages
}

